import { c as _c } from "react/compiler-runtime";
import { IcoTrash16 } from '@onefootprint/icons';
import { IconButton, Tooltip, useConfirmationDialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type DeleteReportButtonProps = {
  name: string;
  isEmpty: boolean;
  onDelete: () => void;
};
const DeleteReportButton = t0 => {
  const $ = _c(17);
  const {
    name,
    isEmpty,
    onDelete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const confirm = useConfirmationDialog();
  let t2;
  if ($[1] !== confirm || $[2] !== isEmpty || $[3] !== name || $[4] !== onDelete || $[5] !== t) {
    t2 = () => {
      if (isEmpty) {
        onDelete();
        return;
      }
      confirm.open({
        title: t(_temp),
        description: t(_temp2, {
          name: name.trim() || t(_temp3)
        }),
        variant: "destructive",
        primaryButton: {
          label: t(_temp4),
          onClick: onDelete
        },
        secondaryButton: {
          label: t(_temp5)
        }
      });
    };
    $[1] = confirm;
    $[2] = isEmpty;
    $[3] = name;
    $[4] = onDelete;
    $[5] = t;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleClick = t2;
  let t3;
  if ($[7] !== t) {
    t3 = t(_temp6);
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t(_temp7);
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleClick || $[12] !== t4) {
    t5 = <IconButton aria-label={t4} icon={IcoTrash16} onClick={handleClick} size="tiny" variant="outline" />;
    $[11] = handleClick;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <Tooltip content={t3}>{t5}</Tooltip>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default DeleteReportButton;
function _temp($) {
  return $.delete.title;
}
function _temp2($_0) {
  return $_0.delete.description;
}
function _temp3($_1) {
  return $_1.untitledReport;
}
function _temp4($_2) {
  return $_2.delete.confirm;
}
function _temp5($_3) {
  return $_3.delete.cancel;
}
function _temp6($_4) {
  return $_4.delete.label;
}
function _temp7($_5) {
  return $_5.delete.label;
}